import React, {Suspense, useEffect} from 'react';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MenuIcon from '@material-ui/icons/Menu';
import Routes from "./routes";
import {connect} from "react-redux";
import MenuDrawer from "./components/MenuDrawer";
import {BrowserRouter as Router, Link} from "react-router-dom";
import {getSupplierDataAction} from "./store/actionCreators";
import ToasterNotificationPanel from "./components/ToasterNotificationPanel";
import {useTranslation} from "react-i18next";
import MessageIcon from '@material-ui/icons/Message'
import Footer from "./components/Footer";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
    },
    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        color: 'white',
        textDecoration: 'none'
    },
    avatar: {
        borderRadius: '50%',
        height: '40px'
    },
    messageUs: {
        position: 'absolute',
        right: '15px',
        top: '18px',
        height: '20px',
        fontSize: '13px',
        borderRadius: '25px',
        border: `1px solid ${theme.palette.white}`,
        color: theme.palette.white,
        width: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1101
    }
}));
const useFetchDataWhenLogin = (authToken, getSupplierData) => {
    useEffect(() => {
        if (authToken) {
            getSupplierData(authToken)
        }
    }, [authToken, getSupplierData])
}

function App({picture, authToken, getSupplierData, dispatch}) {
    useFetchDataWhenLogin(authToken, getSupplierData)
    const classes = useStyles();
    const {t} = useTranslation();
    return (
        <Suspense fallback="loading">
            <Router>
                <div className={classes.root}>
                    <AppBar position="static">
                        <Toolbar>
                            <MenuDrawer>
                                <MenuIcon/>
                            </MenuDrawer>
                            <Link to={'/'}>
                                <Typography variant="h6" className={classes.title}>
                                    {t('app_name')}
                                </Typography>
                            </Link>
                            {picture && <img className={classes.avatar} src={picture} alt={'avatar'}/>}
                        </Toolbar>
                    </AppBar>
                    <div className={classes.content}>
                        <Routes/>
                    </div>
                    <ToasterNotificationPanel/>
                    <a className={classes.messageUs}
                       href="https://wa.me/524426798891"
                       rel="noreferrer nofollow noindex"
                       target="_blank">
                        <MessageIcon color={'inherit'} fontSize={'inherit'}/>
                    </a>
                </div>
            </Router>
        </Suspense>
    );
}

const mapStateToProps = (state) => {
    // console.log(state)
    return {
        // picture: state.general?.auth?.picture?.data?.url,
        authToken: state.general?.auth
    }
}
const mapDispatchToProps = dispatch => ({
    getSupplierData: getSupplierDataAction(dispatch),
    dispatch
})
export default connect(mapStateToProps, mapDispatchToProps)(App);
